module.exports = __webpack_public_path__ + "static/media/ppt.bdeef1e9.png";